import { PopoverSettingComponent } from './../../components/popover-settings/popover-settings';
import { Observable } from "rxjs";
import { Component, ElementRef, ViewChild, Renderer, ChangeDetectorRef } from "@angular/core";
import { NavController, Events, PopoverController, App, LoadingController, Platform } from "ionic-angular";
import { FirebaseService } from "../../services/firebase.service";
import { Users } from "../../models/users";
import { Imybook } from "../../models/mybook";
import { PopOverOptionComponent } from "../../components/pop-over-option/pop-over-option";
import { IBook } from "../../models/book";
import { LoginPage } from "../login/login";
import { AuthService } from "../../services/auth.service";
import { BookDetailPage } from "../book-detail/book-detail";

@Component({
  selector: "page-books-online",
  templateUrl: "books-online.html"
})
export class BooksOnlinePage {
  @ViewChild('variableheight', { read: ElementRef }) text: ElementRef;
  loading: any;

  MyBooks: Imybook[]; //insieme dei miei libri potenzialmente filtrati
  allMybooks: Imybook[]; //insieme competo dei miei libri

  Books: IBook[]; //insieme dei miei libri potenzialmente filtrati

  BooksNews: IBook[];
  BooksSpirituale: IBook[];
  BooksStorica: IBook[];
  BooksBibliotecaRosmini: IBook[];
  BooksLetteraria: IBook[];
  BooksPoetica: IBook[];
  BooksSaggistica: IBook[];
  BooksNarrativa: IBook[];
  BooksQuaderni: IBook[];
  BooksMinima: IBook[];
  BooksFilosofica: IBook[];
  BooksRitorno: IBook[];
  BooksAtti: IBook[];
  BooksTeologica: IBook[];
  BooksTeologiaecclesiale: IBook[];
  BooksPensierosocialecristiano: IBook[];
  Booksvari: IBook[];

  allbooks: IBook[]; //insime competo dei miei libri

  ListBooksCollane: Array<IBook[]> = [];
  ListCollana: string[] = [''];

  userData: Users; //Informazioni dell'utente loggato

  textsrc: string = "";
  onSearch: boolean = false;
  Online: boolean = true;

  variableheight = "240";

  isDesktop:boolean =false;


  constructor(
    public navCtrl: NavController,
    private FireSrvc: FirebaseService,
    private loadinCtrl: LoadingController,
    public events: Events,
    public popoverCtrl: PopoverController,
    public appCtrl: App,
    private AuthSrvc: AuthService,
    private renderer: Renderer,
    private ref: ChangeDetectorRef,
    public platform: Platform,
  ) {

    this.platform.ready().then(() => {

      if (this.platform.is("core")){
  
          this.isDesktop = true;
          console.log(this.isDesktop)
        }});

    this.events.subscribe("network:online", msg => {
      console.log('evento online');
      this.Online = true;
      this.ref.detectChanges();
    });

    this.events.subscribe("network:offline", msg => {
      console.log('evento offline');
      this.Online = false;
      this.ref.detectChanges();
    });


    
  }
  


  ionViewDidLoad() {
    //Carica i dati dell'utente e i libri nella proprio libreria
    this.Inizializza();
   
  }

  Inizializza() {
    if (localStorage.getItem("UserDataLocal")) {
      this.PresentLoading();

      //Carica le info dell'utente
      this.userData = JSON.parse(localStorage.getItem("UserDataLocal"));

      if (localStorage.getItem("Settings")) {
        this.variableheight = localStorage.getItem("Settings");
      } else {
       
        if ( this.isDesktop){
          this.variableheight = "250";
        }else{
          this.variableheight = "150";
        }
        localStorage.setItem("Settings", this.variableheight);
      }

      //carica l'array di libri dal server
      this.loadOnlineBooks();
      this.loadMyBooks();
    }
  }

  //Gestisce il menù in alto a destra
  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopOverOptionComponent);
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(popoverData => {
      // console.log(popoverData);

      if (popoverData == "logout") {
        //  this.PresentLoading();
        this.logout();
      }
    });
  }

  //Gestisce il menù in alto a destra per lo ZOOM delle copertine
  presentPopoverSettings(myEvent) {

    this.events.subscribe('settings:imgsize', (imgsize) => {
      this.variableheight = imgsize;
      localStorage.setItem("Settings", this.variableheight);
    });

    let popover = this.popoverCtrl.create(PopoverSettingComponent, { imgsize: this.variableheight }, { cssClass: 'zoom-popover' });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(popoverData => {
      this.events.unsubscribe('settings:imgsize');
    });
  }

  //mostra il popup di caricamento
  PresentLoading() {
    this.loading = this.loadinCtrl.create({
      spinner: "ios",
      content: "carico libreria..."
      // dismissOnPageChange: true
    });

    this.loading.present();
  }

  //evento di ricerca nella barra
  onInput(e) {
    this.filterBook(this.textsrc);
    this.renderer.invokeElementMethod(e.target, 'blur');
  }
  //svuotamento della ricerca
  onCancel(e) {
    this.filterBook(this.textsrc);
  }

  //Filtra l'array dei libri
  filterBook(textsrc: string) {
    // console.log(this.books);
    if (textsrc.length === 0) {
      //  console.log('svoutato ricerca')

      this.Books = this.allbooks;
      this.onSearch = false;
    } else {
      this.onSearch = true;
      this.Books = this.allbooks;
    }

    //console.log(this.onSearch)
    // this.Books = this.Books.filter(book => book.title.toLowerCase().includes(textsrc.toLowerCase()));

    this.Books = this.Books.filter(function (item) {

      return (item.title.toString().toLowerCase().includes(textsrc.toLowerCase()) ||
        item.autor.toLowerCase().includes(textsrc.toLowerCase()));
    });
  }

  //Chiama il dataProvider per caricare i libri
  loadOnlineBooks() {
    console.log("Carico i libri dal catalogo");

    this.FireSrvc.getBook().subscribe(

      (res: IBook[]) => {

        // this.Online = true;
        //#1.0.2 - Aggiunto filtro per libri con attributo visible = true
        this.Books = res.filter(function (item) {

          return (item.visible.includes('true'))
        });

        this.allbooks = this.Books.slice();

        //#1.0.2 - Aggiunto suddivisione collana
        // let collana = this.FireSrvc.getCollanaOnlineCatalog(this.allbooks);

        // console.log(collana);

        this.SplitBooksCategory();

        this.loading.dismiss();
      },
      err => {
        Observable.throw(err);
        //  this.Online = false;
        console.log(err);
        this.loading.dismiss();
      }
    );
  }

  /**
   *Crea arrey filtrati per collana
   *
   * @memberof BooksOnlinePage
   */
  SplitBooksCategory() {

    this.ListBooksCollane = [];
    this.ListCollana = [''];


    //#1.0.2 - Aggiunto suddivisione collana
    this.allbooks.forEach(book => {
      if (this.ListCollana.find(item => item.toLowerCase().includes(book.collana.toLowerCase()))) {
        // console.log('collana trovata');
      } else {
        // console.log('collana trovata');
        this.ListCollana.push(book.collana);
      }
    });
    //  this.ListCollana.shift();

    this.ListCollana.sort();

    //#1.0.2 - creo array di eBook per collana
    this.ListCollana.forEach(element => {

      let textsrc = element;

      let bookFind = this.Books.filter(function (item) {
        if (item.collana === undefined) {
          item.collana = 'vari';
          return item.collana;
        }
        return (!item.collana === undefined || item.collana.toLowerCase().includes(textsrc.toLowerCase()));
      });

      if (!this.ListBooksCollane) {
        this.ListBooksCollane = [bookFind];
      } else {
        this.ListBooksCollane.push(bookFind);
      }
    });
    this.ListBooksCollane.shift();
    console.log(this.ListBooksCollane[0]);

    this.BooksNews = this.Books.filter(function (item) {

      return (item.news === 'true');
    });
  }

  //Chiama il dataProvider per caricare i libri della propria libreria
  loadMyBooks() {
    console.log("Carico i libri della propria libreria");

    this.FireSrvc.getMybook().subscribe(
      (res: Imybook[]) => {

        this.Online = true;
        this.MyBooks = res;
        this.allMybooks = this.MyBooks.slice();
      },
      err => {
        Observable.throw(err);
        this.Online = false;
        console.log(err);
      }
    );
  }

  //Apre la schermata di dettaglio del libro selezionato
  showBookDetail(book) {
    let isPresent: boolean = false;

    var Present: Imybook[] = this.MyBooks.filter(function (res) {
      return res.id == book.id;
    });

    //Verifica se è già aggiunto alla libreria
    if (Present.length != 0) {
      isPresent = true;
    } else {
      isPresent = false;
    }

    let id: string = this.userData.id;
    // console.log("detaild:" + id);

    //#1.0.2 - aggiunto evento per resettare il filtro di ricerca
    this.events.subscribe('addBook:ok', (res) => {

      console.log(res + ' libro ok devo reset filtro')
      this.textsrc = '';
      this.filterBook('');
      this.events.unsubscribe('addBook:ok');
    });

    this.navCtrl.push(BookDetailPage, {
      book: book,
      iduser: id,
      present: isPresent
    });
  }

  //Evento chiamato dall'utente con il pull-down della pagina
  doRefresh(refresher) {
    this.PresentLoading();
    this.loadOnlineBooks();
    refresher.complete();
  }

  //Esegue il logout e riporta alla schermata di login
  logout() {
    //Salvo nella local storage i dati dell'utente
    this.userData.autologin = false;
    localStorage.setItem("UserDataLocal", JSON.stringify(this.userData));
    this.AuthSrvc.doLogout()
      .then(() => {
        this.appCtrl.getRootNav().setRoot(LoginPage);
      })
      .catch(error => {
        console.error(error);
      });
  }

  changeImgSize() {

    console.log(this.variableheight);
    localStorage.setItem("Settings", this.variableheight);

  }

}



// WEBPACK FOOTER //
// ./src/pages/books-online/books-online.ts